import { ChartWrapper, MainWrapper } from './styles';
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Dynamics from '../../../../../Charts/Dynamics/Dynamics';
import WidgetTitle from '../../../../../Wrappers/WidgetTitle/WidgetTitle';
import WidgetTitleWrapper from '../../../../../Wrappers/WidgetTitleWrapper/WidgetTitleWrapper';
import { Cases_Benchmarks_Traffic_Widgwet_Reducer_Values, reloadWidget } from './reducer';
import { generalReducerValues } from '../../../../../../../General.reducer';
import useChartOptions from './hooks/useChartOptions';
import { useRerender } from '../../../../../../../tools/useRerender';
import { useTranslation } from 'react-i18next';
import { useWidgetCurrentOptions } from '../../../../../../../tools/useWidgetCurrentOptions';
import { withLoading } from '../../../../../../../tools/API/withLoading';
import { TSeries } from '../../../../../Charts/Dynamics/interfaces';
import { AxisLabelsFormatterContextObject } from 'highcharts';
import datetimeFormatHelper from './tools/datetimeFormatHelper';
import usePrepareData from './hooks/usePrepareData';
import WidgetAdditionalControls from '../../../../../WidgetAdditionalControls/WidgetAdditionalControls';

const DynamicsPMO: React.FC = ({}) => {
    const ref = useRef(null);

    const { lang } = useSelector(generalReducerValues);
    const { rowMetricsData, chartOptionsGeneratorSettings, selectedChartDetailing, highlightWeekend } = useSelector(
        Cases_Benchmarks_Traffic_Widgwet_Reducer_Values,
    );

    const options = useChartOptions();
    const rerender = useRerender(chartOptionsGeneratorSettings?.series);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    usePrepareData();

    const WithLoadingTable = withLoading(ChartWrapper, { data: rowMetricsData, height: 400 });

    const xAxisLabelsFormating = function (this: AxisLabelsFormatterContextObject) {
        return datetimeFormatHelper({
            selectedChartDetailing: selectedChartDetailing,
            dateInMillis: this.value as number,
            isCategory: true,
            lang,
            t,
        });
    };

    return (
        <MainWrapper ref={ref}>
            <WidgetTitleWrapper>
                <WidgetTitle>
                    {'Mall Index'}
                    <WidgetAdditionalControls
                        pdfDownloadData={{ targetRef: ref, rerenderKey: rerender }}
                        reloadHandler={reloadWidget}
                        widgetName={'Mall Index'}
                    />
                </WidgetTitle>
            </WidgetTitleWrapper>
            <WithLoadingTable>
                <Dynamics
                    series={chartOptionsGeneratorSettings?.series as TSeries[]}
                    tooltipTitle={'Mall Index'}
                    xAxisLabelsFormating={xAxisLabelsFormating}
                />
            </WithLoadingTable>
        </MainWrapper>
    );
};

export default DynamicsPMO;
